import type { MutableRefObject } from 'react';
import { useRef, useState } from 'react';

/**
 * Creates a ref object like React’s `useRef`, but instead of providing
 * it the value directly, you provide a function that returns the value.
 * The first time the hook is run, it will call the function and use
 * the returned value as the initial ref.current value.
 * Afterwards, the function is never invoked.
 * You can use this for creating refs to values that are expensive to initialize.
 */
export function useLazyRef<T>(getValue: () => T): MutableRefObject<T> {
    const [value] = useState<T>(getValue);
    const ref = useRef<T>(value);

    return ref;
}
